import React, { useMemo } from "react";
import { fmt } from "../../services/formatting";
import { MODALIDADES } from "../../constants";
import { getKnownPlatforms } from "../../services/platformCatalog";

/**
 * Filter panel component with buy-in, modality, and date range filters
 */
export const FilterPanel = ({ filters, onChange, tournaments, registros = [], onClear }) => {
  const buyins = useMemo(
    () =>
      [...new Set(tournaments.map((t) => t.buyin))].sort(
        (a, b) => Number(a) - Number(b)
      ),
    [tournaments]
  );
  const platforms = useMemo(
    () => getKnownPlatforms(tournaments, registros),
    [tournaments, registros]
  );
  const active = Object.values(filters).some((v) => v !== "");

  return (
    <div className="filter-panel motion-expand-panel">
      <div>
        <label className="field-label">Buy-in</label>
        <select
          className="input-field"
          value={filters.buyin}
          onChange={(e) => onChange({ ...filters, buyin: e.target.value })}
        >
          <option value="">Todos</option>
          {buyins.map((b) => {
            const tournament = tournaments.find((t) => t.buyin === b);
            return (
            <option key={b} value={b}>
              {fmt(b, tournament?.buyinCurrency)}
            </option>
          )})}
        </select>
      </div>

      <div>
        <label className="field-label">Plataforma</label>
        <select
          className="input-field"
          value={filters.plataforma}
          onChange={(e) => onChange({ ...filters, plataforma: e.target.value })}
        >
          <option value="">Todas</option>
          {platforms.map((platform) => (
            <option key={platform} value={platform}>
              {platform}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="field-label">Modalidade</label>
        <select
          className="input-field"
          value={filters.modalidade}
          onChange={(e) =>
            onChange({ ...filters, modalidade: e.target.value })
          }
        >
          <option value="">Todas</option>
          {MODALIDADES.map((m) => (
            <option key={m} value={m}>
              {m}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="field-label">Data início</label>
        <input
          className="input-field"
          type="date"
          value={filters.dataInicio}
          onChange={(e) =>
            onChange({ ...filters, dataInicio: e.target.value })
          }
        />
      </div>

      <div>
        <label className="field-label">Data fim</label>
        <input
          className="input-field"
          type="date"
          value={filters.dataFim}
          onChange={(e) =>
            onChange({ ...filters, dataFim: e.target.value })
          }
        />
      </div>

      {active && (
        <div className="filter-panel__clear">
          <button
            className="btn-ghost filter-panel__clear-button"
            onClick={onClear}
          >
            ✕ Limpar filtros
          </button>
        </div>
      )}
    </div>
  );
};

export default FilterPanel;
